export const ScopeViewSwitch = ({ value, onChange, canViewCompany, testidPrefix }) => (
  <div className="scope-view-switch" data-testid={`${testidPrefix}-scope-view-switch`}>
    <span>Görünüm</span>
    <button data-testid={`${testidPrefix}-scope-self-button`} type="button"
      className={value === "self" ? "selected" : ""} onClick={() => onChange("self")}>Kendim</button>
    {canViewCompany && <button data-testid={`${testidPrefix}-scope-company-button`} type="button"
      className={value === "company" ? "selected" : ""} onClick={() => onChange("company")}>Tüm Şirket</button>}
  </div>
);